import * as ProgressPrimitive from "@radix-ui/react-progress";

const Progress = ProgressPrimitive.Root;
const ProgressIndicator = ProgressPrimitive.Indicator;

export { Progress, ProgressIndicator };
